import { apiClient } from 'pobble-components/dist/api'
import { setToken } from 'pobble-components/dist/auth-helpers'

export const apiGetMe = params => apiClient.get('v3/me', { params })

export const apiUpdateAccountDetails = (data, params) =>
  apiClient.put(`v3/me/account_details`, data, { params })

export const apiUpdateAccountEmail = (id, data) =>
  apiClient.put(`/v3/email_identities/${id}/request_email_change`, data)

export const apiUploadAvatar = (id, img) => {
  const formData = new FormData()
  formData.append('avatar', img)
  return apiClient.post(`v3/accounts/${id}/avatars`, formData)
}

export const apiRemoveAvatar = id =>
  apiClient.delete(`v3/accounts/${id}/avatars`)

export const apiUpdateAccountPassword = (emailId, data, params) =>
  apiClient
    .put(`v3/email_identities/${emailId}/update_password`, data, { params })
    .then(res => setToken(res.data.jwt))

export const apiGetChildren = params =>
  apiClient.get(
    'v3/me?include=account.parent_types,account.parent_type.student_type.account,account.parent_type.student_type.account.names,account.parent_type.student_type.account.avatar,account.parent_type.status.student_types'
  )

export const apiUpdateStudentAvatar = (id, color, code) =>
  apiClient.post(`v3/accounts/${id}/student_avatars`, { color, code })

export const apiGenerateStudentDisplayname = () =>
  apiClient.get('v3/accounts/generate_display_name')

export const apiApproveStudent = (data, params) =>
  apiClient.post(`v3/parent_permissions/approve`, data, { params })

export const apiDeclineStudent = (data, params) =>
  apiClient.post(`v3/parent_permissions/disapprove`, data, { params })

export const apiRemoveStudent = (data, params) =>
  apiClient.post(`v3/parentships/unassign`, data, { params })

export const apiSearchAllSchools = params =>
  apiClient.get('/v3/schools_search?all_schools=true', { params })

export const apiDeletePendingTeacher = userId =>
  apiClient.delete(`v3/pending_teachers/${userId}`)

export const apiScheduleSubscriptionCancelation = () =>
  apiClient.post(`v3/me/subscriptions/schedule_cancellation`)

export const apiUpdateRole = data => apiClient.post(`v3/me/role_in_life`, data)

export const apiConnectToStudent = (schoolId, data, params) =>
  apiClient.post(`v3/schools/${schoolId}/parent_codes`, data, { params })
